import { ELanguage, EPages } from '@microfrontends/app-shell-v2'
import { IUser } from '../auth/@type'
import { IFeaturedJobs, IJobItem } from '../Jobs/@type'

export interface IMeta {
	code?: number | null
	hitsPerPage?: number | null
	message?: string | null
	nbHits?: number | null
	nbPages?: number | null
	page?: number | null
}
export interface IJobSearch {
	data?: IJobItem[] | null
	facets?: {
		companies: object
		cityIds: number | null
	}
	meta?: IMeta | null
}

export interface IFeaturedJobsResponse {
	data?: IFeaturedJobs[] | null
	facets?: {
		companies: object
		cityIds: number | null
	}
	meta?: IMeta | null
}

export interface IRecommendedData {
	jobs?: IJobItem[] | null
	source?: string | null
	total: number | null
	totalPage?: number | null
}

export enum ETypeNumerologyPage {
	HomeNumerology = 'HomeNumerology',
	DetailNumerology = 'DetailNumerology',
	HomeCareerPath = 'HomeCareerPath',
	DetailCareerPath = 'DetailCareerPath'
}

export interface INewPageProps<D = any> {
	user: IUser | null
	userIP: string
	data?: D
}

export default interface IPageProps {
	tReady?: boolean
	user: IUser | null
	children: JSX.Element
	userIP?: string
	hiddenMenu?: number[]
	hiddenHeader?: boolean
	languageCode: ELanguage
	pageName: EPages
	numerologyPage?: ETypeNumerologyPage
	metaKeywords?: string
	metaTitle?: string
	metaCanonical?: string
	metaDescription?: string
	data?: any
	isRobot?: boolean
	jobId?: number
	t: (key: string) => string
}
